import { render, staticRenderFns } from "./LiefengorganizationModel.vue?vue&type=template&id=3f5a32a8&scoped=true&"
import script from "./LiefengorganizationModel.vue?vue&type=script&lang=js&"
export * from "./LiefengorganizationModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5a32a8",
  null
  
)

export default component.exports